import React from "react";
import LoginForm from "../../forms/auth/LoginForm";
import { makeStyles, Box } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "20%",
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(0),
    },
  },
}));

const LoginView = ({ onSubmit = () => {}, initialValues }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <LoginForm onSubmit={onSubmit} initialValues={initialValues} />
    </Box>
  );
};

export default LoginView;
